<script lang="ts" setup>
import { h, onMounted, ref } from '#imports';
import { CaretDownOutlined } from '@ant-design/icons-vue';
import { useService } from '@kaokei/use-vue-service';
import { ZoneService } from '@core/services/zone.service';
import { ZONE_OPTIONS } from '@core/utils/constant';
import HTLinkButton from './HTLinkButton.vue';

defineOptions({
  inheritAttrs: false,
});

const zoneService = useService(ZoneService);

const popoverOpen = ref(false);
const conRef = ref();

const handleChange = (zone: any) => {
  window.hetaoTrack('zoneselect_navigate_confirm_click', { zone });
  window.setTimeout(() => {
    zoneService.updateZone(zone);
  }, 200);
};

const handleHidePopover = () => {
  popoverOpen.value = false;
  zoneService.removeZoneGuide();
};

onMounted(() => {
  const needShow = zoneService.needShowZoneGuide();
  if (needShow) {
    popoverOpen.value = true;
  }
});
</script>

<template>
  <div ref="conRef">
    <a-popover
      placement="bottom"
      :open="popoverOpen"
      :get-popup-container="() => conRef"
      :align="{
        offset: [0, 10],
      }"
    >
      <a-select
        v-track:zoneselect_navigate_click.click
        v-bind="$attrs"
        :value="zoneService.zone"
        :options="ZONE_OPTIONS"
        :bordered="false"
        :dropdown-match-select-width="false"
        placement="bottomLeft"
        :suffix-icon="h(CaretDownOutlined)"
        class="fix-select"
        @change="handleChange"
        @dropdown-visible-change="handleHidePopover"
      >
      </a-select>

      <template #content>
        <div class="whitespace-nowrap px-2 py-[3px]">
          <span class="text-title text-base"
            >点击这里可以切换Python/C++的内容哦</span
          >
          <HTLinkButton class="ml-5 !text-[#3864FF]" @click="handleHidePopover"
            >我知道了</HTLinkButton
          >
        </div>
      </template>
    </a-popover>
  </div>
</template>

<style scoped>
.fix-select :deep(.ant-select-selection-item) {
  font-size: 16px;
}
</style>
